import type { LiveSessionResponse } from "@memorang/types/src/session/new-session";
import postTest from "../proethica-test-sessions/posttest.json";
import preTest from "../proethica-test-sessions/pretest.json";
import {
	type ProethicaTestKind,
	proethicaTestDescriptors,
} from "../proethica-tests";

const asEnvelope = (json: unknown) => json as unknown as LiveSessionResponse;

const envelopeByKind: Record<ProethicaTestKind, LiveSessionResponse> = {
	pretest: asEnvelope(preTest),
	posttest: asEnvelope(postTest),
};

// Pre/post tests enter the session store through the same boundary adapter as
// modules (normalizeProethicaSessionResponse). Keyed by descriptor id because
// the dashboard stores that id as currentModuleId when a test row is tapped.
export const proethicaTestEnvelopeByModule: Record<
	string,
	LiveSessionResponse
> = Object.fromEntries(
	proethicaTestDescriptors.map((test) => [test.id, envelopeByKind[test.kind]]),
);

// SUMMATIVE/PRACTICE_TEST create-params, used only once isLiveSession flips; the
// envelopes above are served directly under mock data.
export const proethicaTestSessionConfig = {
	projectId: 26,
	organizationId: 24,
	sessionType: "SUMMATIVE",
	sessionSubType: "PRACTICE_TEST",
} as const;

const collectionIdByKind = Object.fromEntries(
	proethicaTestDescriptors.map((test) => [test.kind, test.collectionId]),
) as Record<ProethicaTestKind, number>;

export const getProethicaTestCreateParams = (kind: ProethicaTestKind) => ({
	...proethicaTestSessionConfig,
	collectionId: collectionIdByKind[kind],
});
